module.exports = __webpack_public_path__ + "static/img/img_0723.d15210b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0723.jpg
// module id = r/6x
// module chunks = 0